import React, { Component } from 'react'
import { compose } from 'recompose'
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux'
import { withStyles, ListItem } from '@material-ui/core';
import * as routes from '../../../constants/routes';
import { Link } from 'react-router-dom';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import PeopleIcon from '@material-ui/icons/People';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import MailIcon from '@material-ui/icons/Mail';
import HomeIcon from '@material-ui/icons/Home';
import CheckIcon from '@material-ui/icons/Check';
import AccountIcon from '@material-ui/icons/AccountBox';
import PersonIcon from '@material-ui/icons/Person';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import RemoveIcon from '@material-ui/icons/RemoveCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import AccountCircle from '@material-ui/icons/AccountCircle'


const styles = theme =>({
    drawer: {
        padding: '16px'
    },
    navTitle : {
        padding: theme.spacing.unit,
        backgroundColor: theme.palette.primary.dark,
        color: 'white',
        fontSize: '1em',
        letterSpacing: '2px'


    },
    navSectionHeadline : {
        marginTop: theme.spacing.unit,
        padding: theme.spacing.unit,
        backgroundColor: theme.palette.primary.light,
        color: 'white',
        //fontWeight: 'bold'
    },
    navItemLink: {
        textDecoration: 'none',
    },
    navItem: {
        
    },
    navItemActive: {
        backgroundColor: '#3f51b5',//'#7986cb',
    },
    navItemIcon: {
        color: theme.palette.primary.dark, //'#3f51b5'
    },
    navItemIconActive: {
        color: 'white'
    },
    navItemText: {
        color: theme.palette.primary.dark,
    },
    navItemTextActive : {
        color: 'white',
    }
})


class MobileNav extends Component {
    constructor () {
        super()
        this.state = {
            activeNav: ''
            
        }
    }

    componenDidMount () {
     //   console.log('Component did mount')
        //this.props.onToggleDrawer(true)
    }

   

    icons = {
        home: <HomeIcon />,
        inbox: <InboxIcon />,
        mail: <MailIcon  />,
        check: <CheckIcon />,
        checkBox: <CheckBoxIcon />,
        account: <AccountIcon />,
        person: <PersonIcon />,
        personAdd: <PersonAddIcon />,
        groupAdd: <GroupAddIcon />,
        group: <PeopleIcon />,
        delete: <DeleteIcon />,
        remove: <RemoveIcon />,
        online: <AccountCircle style={{color: 'green'}}/>,
    }

    requesterItems = [
        {
            lable: 'Startseite',
            link: routes.LANDING,
            icon: 'home',
            divider: true
        },
        {
            lable: 'Benutzerkonto',
            link: routes.ACCOUNT,
            icon: 'account',
        },
        {
            headline: 'Ich suche Hilfe'
        },
        {
            lable: 'Hilfebedarf erstellen',
            link: routes.ADDEVENT,
            icon: 'checkBox',
            divider: true,
        },
        {
            lable: 'Mein Hilfebedarf',
            link: routes.EVENTS,
            icon: 'group',
        }
    ]

    canidateItems =  [
        {
            headline: 'Ich biete Hilfe'
        },
        {
            lable: 'Nachrichten Center',
            link: routes.MY_MESSAGING_CENTER,
            icon: 'mail',
            divider: true,
        },  
        {
            lable: 'Hilfeangebot',
            link: routes.CANIDATELIST,
            icon: 'groupAdd',
            //divider: true,
        },
    ]

    adminItems = [
        {
            headline: 'Admin Hilfegesuch Verwaltung'
        },
        {
            lable: 'Admin Home',
            link: routes.ADMINHOME,
            icon: 'person',
            //divider: true,
        },
        {
            lable: 'Hilfebedarf vermitteln',
            link: routes.ADMINEVENTS,
            icon: 'group',
            //divider: 'true'
        },
        {
            lable: 'Hilfebedarf für Helfer bestätigen',
            link: routes.ADMIN_CONNECTED_EVENTS,
            icon: 'check',
            divider: true,
        },
        {
            lable: 'Hilfebedarf abgeschlossen',
            link: routes.ADMIN_CONFIRMED_EVENTS,
            icon: 'checkBox',
            divider: true
        },
        {
            lable: 'Hilfebedarf für Mitglied erstellen',
            link: routes.ADMIN_ADD_EVENT,
            icon: 'personAdd',
            //divider: true,
        },
        {
            headline: 'Admin Benutzer Verwaltung'
        },
        {
            lable: 'Mitglieder freischalten',
            link: routes.ADMIN_USER_MGM,
            icon: 'groupAdd',
            divider: true,
        },
        {
            lable: 'App Benutzer deaktivieren',
            link: routes.ADMIN_UNLOCKED_USER,
            icon: 'remove',
            divider: true,
        },
        {
            lable: 'App Benutzer online',
            link: routes.ADMIN_USERS_ONLINE,
            icon: 'online',
            divider: true,
        },        
    ]


    navItems = {
        requester : [
            ...this.requesterItems
        ],
        canidate : [
            ...this.requesterItems,
            ...this.canidateItems
        ],
       
        admin : [
            ...this.requesterItems,
            ...this.canidateItems,
            ...this.adminItems
        ]
    
    }

    setNavItemActive = (navLable) => {
        this.setState({activeNav: navLable})
    }


    activeStyle = {color: 'white'}
    style = {color: 'black'}

   renderNavItems = (navItems) => {
      
       const { classes } = this.props
        return (
            navItems.map((navItem, index)=> {
                const isActive = navItem.lable===this.state.activeNav
                if(typeof(navItem.headline)!=='undefined')
                return <div key={index} className={classes.navSectionHeadline}>{navItem.headline}</div>
                return (
                        <Link className={classes.navItemLink} key={index} to={navItem.link}>
                            <ListItem 
                                className={isActive ? classes.navItemActive : classes.navItem} 
                                onClick={()=>this.setNavItemActive(navItem.lable)}
                                button
                                divider={typeof(navItem.divider)!=='undefined' ? true : false}
                            >
                                <ListItemIcon className={isActive ? classes.navItemIconActive : classes.navItemIcon}>{this.icons[navItem.icon]}</ListItemIcon>
                                <ListItemText 
                                    primaryTypographyProps={{className: isActive ? classes.navItemTextActive : classes.navItemText}}
                            
                                    primary={navItem.lable} />
                            </ListItem>

                        </Link>
                     
                   
                )
            })
        )

    }

 
    render () {
        const { onToggleDrawer, classes, userProfile} = this.props
        return (
                <Drawer className={classes.drawer} open={this.props.drawerState} onClose={()=>onToggleDrawer(false)}> 
                    <div className={classes.navTitle}>Navigation</div>      
                    <div
                    tabIndex={0}
                    role="button"
                    onClick={()=>onToggleDrawer(false)}
                    onKeyDown={()=>onToggleDrawer(false)}
                    >
                    <List component='nav'>
                        {this.renderNavItems(this.navItems[userProfile.role])}
                    </List>
                    </div>
                   
                </Drawer>
        )
    }
}

const mapStateToProps = state => ({
    userProfile: state.userState.profile,
    drawerState: state.appState.drawerState
})

const mapDispatchToProps = (dispatch) => ({
    onToggleDrawer: (value) => dispatch({type: 'TOGGLE_DRAWER', value})
  });

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(MobileNav)


// WEBPACK FOOTER //
// ./src/Components/Navigation/MobNav/MobNav.js